import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import loSto from '../config/loSto'
import {
  LO_STO,
  EDITOR_TYPE,
  setToast,
  showSettings,
  isCerner,
  SETTINGS_VIEW,
  generateDestinations
} from '../lib'
import { Constants } from '@sukiai/components'
import styled from 'styled-components'
import Editor, { V2_DEFAULT_CONTENT } from '@sukiai/quill-editor'
import {
  CreateNoteType,
  UpdateNoteType
} from '@sukiai/gql/app'
import omitDeep from 'omit-deep-lodash'
import { get } from 'lodash'
import {
  InvisibleContainer,
  Container,
  Body,
  Button,
  HeaderActions,
  ScriptNameInput,
  ScriptNameTip,
  SectionOptions
} from './newScriptModal'
import DeleteItemModal from './DeleteItemModal'
import closeButton from '../lib/assets/icons/closeButton.png'
import checkGreen from '../lib/assets/icons/check-green.svg'
import { GetEmrNotetypes } from '@sukiai/gql/src/app/NoteTypes'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { logger } from '../lib/logging'
import { isOrgEmrIntegrated } from '../lib/util'

const { TOAST } = Constants

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // styles we need to apply on draggables
  ...draggableStyle
})

const getListStyle = isDraggingOver => ({
  width: '100%'
})

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const AddSectionContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;

  .add-section-btn {
    color: #2e5f62;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    border: 0px;
    background: none;
    font-family: 'Open Sans';
  }
`

const AddSectionButton = styled.button`
  &:hover {
    background-color: rgba(33, 33, 33, 0.03);
  }
  padding: 10px;
`

const DeleteSectionButton = styled.img.attrs({
  src: closeButton
})`
  width: 26px;
  height: 26px;
  margin: 0px 20px 0px auto;
`

const SectionItem = styled.div`
  display: flex;
  justify-content: justify-start;
  align-items: center;
`

const ProblemBasedLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(33, 33, 33, 0.03);
  font-size: 8pt;
  width: 104px !important;
  height: 32px;
  margin-left: 20px;
  text-align: center;
  border-radius: 4px;
`

export const SectionBlock = styled.div`
  position: relative;
  width: 100%;
  margin-top: 20px;
`

const NoteCategoryContainer = styled.div`
  color: gray;
  width: 400px;
  &:hover {
    background-color: rgba(33, 33, 33, 0.03);
  }
  margin: 0px auto 20px 0px;
  height: 60px;
`

const SelectLabel = styled.div`
  font-size: 10pt;
  color: rgba(0, 0, 0, 0.35);
`

const Platter = styled.div`
  display: flex;
  align-items: center;
  width: 420px;
  border-radius: 5px;
  font-family: 'Open Sans';
  padding: 10px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  position: relative;
  margin-bottom: 12px;

  &:hover {
    background-color: ${props => props.disabled ? 'none' : 'rgba(0, 0, 0, 0.03)'};
  }

  .label {
    margin: 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
  }

  .section-name {
    font-size: 16px;
    color: #000000;
    margin: 0;
    margin-top: 5px;
    font-weight: 600;
  }
`

export const CategoryPlatter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 420px;
  border-radius: 5px;
  font-family: 'Open Sans';
  padding: 10px;
  cursor: pointer;
  position: relative;
  margin-bottom: 12px;

  .label {
    margin: 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
  }

  .section-name {
    font-size: 16px;
    color: #000000;
    margin: 0;
    margin-top: 5px;
    font-weight: 600;
  }
`

class NotetypeEditor extends Component {
  state = {
    isCreateOrUpdating: false,
    noteTypeName: get(this.props, 'cachedNoteType.name', ''),
    noteTypeSections: get(this.props, 'cachedNoteType.sections', []),
    emrNoteType: get(this.props, 'cachedNoteType.emrNoteType'),
    sectionOptionsOpen: null,
    showDeleteSection: ''
  }

  componentWillMount = () => {
    const { client } = this.props
    loSto.set(LO_STO.SETTINGS_VIEW, SETTINGS_VIEW.NOTETYPES)
    if (!isCerner()) {
      return
    }
    client.query({
      query: GetEmrNotetypes,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        specialties: loSto.get(LO_STO.CURRENT_USER)?.specialties
      }
    }).then(res => {
      const ntCategories = res?.data?.emrNoteTypes?.emrNoteTypes
      this.setState({ ntCategories })
    }).catch(err => {
      this.setState({ ntCategories: [] })
      console.error('Error retrieving EMR note types', err)
    })
  }

  componentDidMount = async () => {
    document.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClick)
  }

  componentWillReceiveProps (nextProps) {
    nextProps.shouldDismiss && this.props.open && nextProps.removeModal()
  }

  handleClose = () => {
    this.setState({ isCreatingScript: false })
    showSettings()
  }

  handleClick = e => {
    // this method is for closing the section list
    const { sectionOptionsOpen, categoryOptionsOpen } = this.state
    if (sectionOptionsOpen === null && categoryOptionsOpen === null) {
      return
    }
    const isSectionDropDown = e.target.classList.contains('section-dropdown')
    if (!isSectionDropDown) {
      this.setState({ sectionOptionsOpen: false })
    }

    const isCategoriesDropdown = e.target.classList.contains('categories-dropdown')
    if (!isCategoriesDropdown) {
      this.setState({ categoryOptionsOpen: false })
    }
  }

  handleCreateNoteType = () => {
    const { client } = this.props
    const {
      noteTypeName,
      noteTypeSections,
      emrNoteType,
      cachedNoteType,
      isNewSectionBeingCreated
    } = this.state

    if (noteTypeName === '') {
      setToast(TOAST.TYPE.ERROR, 'Please name your Note Type.', TOAST.DURATION.MEDIUM)
      return
    }

    if (noteTypeSections.length === 0) {
      setToast(TOAST.TYPE.ERROR, 'Please add sections to your Note Type.', TOAST.DURATION.MEDIUM)
      return
    }

    if (isNewSectionBeingCreated) {
      setToast(TOAST.TYPE.ERROR, 'Oops! Please ensure your sections have names, or delete ones you no longer need.', TOAST.DURATION.MEDIUM)
      return
    }

    const primaryDest = cachedNoteType?.destinations?.[0]
    if (isCerner() && (primaryDest !== 'SUKI_ONLY')) {
      if (!emrNoteType) {
        setToast(TOAST.TYPE.ERROR, 'Please select Note Category.', TOAST.DURATION.MEDIUM)
        return
      }
    }

    const newEmrNoteType = omitDeep(emrNoteType, '__typename')

    const sections = noteTypeSections.filter(nts => nts.id !== 'new-section')

    // set loading state
    this.setState({ isCreateOrUpdating: true })
    client.mutate({
      mutation: CreateNoteType,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        noteType: {
          userId: loSto.get(LO_STO.USER_ID),
          name: noteTypeName,
          destinations: generateDestinations(),
          sections: sections,
          emrNoteType: newEmrNoteType,
          source: 'USER'
        }
      }
    }).then(() => {
      showSettings()
      setToast(TOAST.TYPE.PRIMARY, 'Note Type created', TOAST.DURATION.MEDIUM)
      this.setState({ isCreateOrUpdating: false })
    }).catch((err) => {
      console.error('Error creating Note Type', err)
      setToast(TOAST.TYPE.ERROR, 'Error creating Note Type. Please try again.', TOAST.DURATION.MEDIUM)
      this.setState({ isCreateOrUpdating: false })
    })
  }

  updateNoteType = () => {
    const { client, cachedNoteType } = this.props
    const { noteTypeName, noteTypeSections, emrNoteType, isNewSectionBeingCreated } = this.state

    if (noteTypeName === '') {
      setToast(TOAST.TYPE.ERROR, 'Please name your Note Type.', TOAST.DURATION.MEDIUM)
      return
    }

    if (noteTypeSections.length === 0) {
      setToast(TOAST.TYPE.ERROR, 'Please add sections to your Note Type.')
      return
    }

    if (isNewSectionBeingCreated) {
      setToast(TOAST.TYPE.ERROR, 'Oops! Please ensure your sections have names, or delete ones you no longer need.', TOAST.DURATION.MEDIUM)
      return
    }

    this.setState({ isCreateOrUpdating: true })

    const newEmrNoteType = omitDeep(emrNoteType, '__typename')

    const sections = noteTypeSections.filter(nts => nts.id !== 'new-section')

    const newNoteType = {
      id: cachedNoteType.id,
      userId: loSto.get(LO_STO.USER_ID),
      name: noteTypeName,
      destinations: cachedNoteType.destinations,
      sections: sections,
      emrNoteType: newEmrNoteType,
      source: 'USER'
    }

    return client.mutate({
      mutation: UpdateNoteType,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        noteType: newNoteType
      }
    })
  }

  handleUpdateNoteType = () => {
    this.updateNoteType().then((res) => {
      showSettings()
      setToast(TOAST.TYPE.PRIMARY, 'Notetype updated', TOAST.DURATION.MEDIUM)
      this.setState({ isCreateOrUpdating: false })
    }).catch((err) => {
      console.error('Error updating Note Type', err)
      setToast(TOAST.TYPE.ERROR, 'Error updating Note Type. Please try again.', TOAST.DURATION.MEDIUM)
      this.setState({ isCreateOrUpdating: false })
    })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleAddSection = () => {
    const { noteTypeSections } = this.state
    const sectionListArray = [...noteTypeSections]

    // TODO: new section should not be mapped to section

    const newSection = {
      id: 'new-section',
      name: 'n/a',
      navigationKeywords: [],
      content: V2_DEFAULT_CONTENT,
      pbcSectionFlag: false
    }

    sectionListArray.push(newSection)
    this.setState({
      isNewSectionBeingCreated: true,
      noteTypeSections: sectionListArray,
      sectionOptionsOpen: sectionListArray.length - 1
    })
  }

  onEditorChange = (newValue, blockIdx) => {
    const { noteTypeSections } = this.state

    const newSections = [...noteTypeSections]

    newSections[blockIdx].content = newValue
    this.setState({ noteTypeSections: newSections })
  }

  openCategorySelection = e => {
    this.setState({ categoryOptionsOpen: true })
  }

  openSectionSelection = (e, blockId) => {
    const isDeleteSectionButton = e.target.classList.contains('delete-section-button')
    if (isDeleteSectionButton) {
      return
    }
    this.setState({ sectionOptionsOpen: blockId })
  }

  onSelectSection = (noteTypeSectionIdx, section, currentSectionId, e) => {
    e.stopPropagation()

    const { noteTypeSections } = this.state
    const sectionListArray = [...noteTypeSections]

    const newSection = {
      id: section.id,
      name: section.name,
      navigationKeywords: section.hints,
      content: V2_DEFAULT_CONTENT,
      pbcSectionFlag: section.pbcSectionFlag
    }

    if (newSection.pbcSectionFlag) {
      if (sectionListArray.filter(s => s.pbcSectionFlag && (s.id !== currentSectionId)).length === 1) {
        setToast(TOAST.TYPE.WARNING, 'Sorry, only one problem-based section is allowed per note type.', TOAST.DURATION.MEDIUM)
        return
      }
    }

    sectionListArray[noteTypeSectionIdx] = newSection

    this.setState({
      noteTypeSections: sectionListArray,
      sectionOptionsOpen: null,
      isNewSectionBeingCreated: false
    })
  }

  handleMouseOver = sectionId => {
    this.setState({ showDeleteSection: sectionId })
  }

  handleMouseLeave = () => {
    this.setState({ showDeleteSection: '' })
  }

  deleteSectionAtIndex = idx => {
    const { noteTypeSections, isNewSectionBeingCreated } = this.state
    const sectionListArray = [...noteTypeSections]

    const deletedSection = sectionListArray.splice(idx, 1)
    this.setState({
      noteTypeSections: sectionListArray,
      showDeleteModal: false
    })

    if (isNewSectionBeingCreated && deletedSection?.[0]?.id === 'new-section') {
      this.setState({ isNewSectionBeingCreated: false })
    }
  }

  deleteSection = sectionId => {
    const { noteTypeSections } = this.state

    const sectionListArray = [...noteTypeSections]
    const idxToDelete = sectionListArray.findIndex(section => section.id === sectionId)

    const sectionToDelete = sectionListArray[idxToDelete]
    const contentToDelete = sectionToDelete.content

    if (JSON.stringify(JSON.parse(V2_DEFAULT_CONTENT)) !== JSON.stringify(JSON.parse(contentToDelete))) {
      this.setState({ showDeleteModal: true, idxToDelete: idxToDelete })
      return
    }

    this.deleteSectionAtIndex(idxToDelete)
  }

  handleDeleteSection = (e, sectionId) => {
    e.preventDefault()
    this.deleteSection(sectionId)
  }

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false })
  }

  handleCategoryClick = category => {
    this.setState({
      emrNoteType: category,
      categoryOptionsOpen: false
    })
  }

  handleDragEnd = (result) => {
    const { noteTypeSections } = this.state

    // dropped outside the list
    if (!result.destination) {
      return
    }

    const items = reorder(
      noteTypeSections,
      result.source.index,
      result.destination.index
    )

    this.setState({
      noteTypeSections: items,
      isDragging: false
    })
  }

  handleStartDrag = () => {
    this.setState({ isDragging: true })
  }

  onHandleUnidecode = (event) => {
    const noteTypeId = get(this.props, 'cachedNoteType.id')
    const { beforeText, afterText } = event

    logger.info(`[Unidecode Conversion] - NoteTypeId: ${noteTypeId} | Before: ${beforeText} | After: ${afterText} `)
    setToast(TOAST.TYPE.INFO, 'Converted unsupported text', TOAST.DURATION.SHORT)
  }

  renderNewSectionBlock = (block, blockIdx, isReadOnly, isNewSection) => {
    // TODO: Refactor to a different component
    const { sections } = this.props
    const {
      sectionOptionsOpen,
      noteTypeSections,
      showDeleteSection
    } = this.state

    const section = { ...noteTypeSections[blockIdx] }
    const sectionContent = section?.content
    const sectionName = isNewSection ? 'Select a Section' : section?.name
    const sectionNameStyle = isNewSection
      ? { color: 'gray' }
      : {}

    return (
      <Draggable key={block.id} draggableId={block.id} index={blockIdx}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <SectionBlock key={block.id + blockIdx}>
              <Platter
                onClick={e => isReadOnly ? () => { } : this.openSectionSelection(e, blockIdx)}
                onMouseOver={() => isReadOnly ? () => { } : this.handleMouseOver(block.id)}
                onMouseLeave={() => isReadOnly ? () => { } : this.handleMouseLeave(block.id)}
                disabled={isReadOnly}
                className='platter'
              >
                <p className='section-name' style={sectionNameStyle}>{sectionName}</p>
                {section.pbcSectionFlag && <ProblemBasedLabel>Problem Based</ProblemBasedLabel>}
                {showDeleteSection === block.id &&
                  <DeleteSectionButton onClick={e => this.handleDeleteSection(e, block.id)} className='delete-section-button' />}
              </Platter>
              {sectionOptionsOpen === blockIdx && (
                <SectionOptions className='section-dropdown'>
                  {sections.map((section, idx) => {
                    const sectionAlreadyInNt = noteTypeSections.some(s => s.id === section.id)
                    const handleClick = sectionAlreadyInNt ? () => { } : e => this.onSelectSection(blockIdx, section, block.id, e)
                    const sectionName = section.name.replace(/\s+/g, '-').toLowerCase()
                    return (
                      <SectionItem
                        key={idx}
                        onClick={handleClick}
                        className='section-dropdown'
                        data-cy={`section-dropdown-${sectionName}`}
                      >
                        {section?.name}
                        {section.pbcSectionFlag && (
                          <ProblemBasedLabel className='section-dropdown'>
                            Problem Based
                          </ProblemBasedLabel>
                        )}
                        {sectionAlreadyInNt && (
                          <img src={checkGreen} width='20' height='20' style={{ marginLeft: 'auto' }} />
                        )}
                      </SectionItem>
                    )
                  })}
                </SectionOptions>)}

              <Editor
                defaultValue={sectionContent}
                s2Mode={false}
                persona='PHYSICIAN'
                editorType={EDITOR_TYPE.NOTETYPE}
                onChange={val => this.onEditorChange(val, blockIdx)}
                placeholder='Enter content (optional)'
                readOnly={isReadOnly}
                data-cy='add-note-type-enter-content'
                style={{
                  fontSize: '10px',
                  borderRadius: '4px',
                  padding: '5px',
                  boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.3)'
                }}
                handleUnidecode={this.onHandleUnidecode}
                enableUnidecoding
                enableChips={isOrgEmrIntegrated()}
              />
            </SectionBlock>
          </div>)}
      </Draggable>
    )
  }

  render () {
    const {
      isCreateOrUpdating,
      noteTypeName,
      idxToDelete,
      showDeleteModal,
      emrNoteType,
      categoryOptionsOpen,
      ntCategories,
      isNewSectionBeingCreated,
      isDragging
    } = this.state
    const { isCreate, cachedNoteType } = this.props

    const handleCreateOrUpdate = isCreate ? this.handleCreateNoteType : this.handleUpdateNoteType

    const primaryDest = cachedNoteType?.destinations?.[0]
    const shouldShowCategories = isCerner() && (primaryDest !== 'SUKI_ONLY')

    return (
      <div>
        <InvisibleContainer>
          <Container onClick={e => e.stopPropagation()}>
            <Body>
              <HeaderActions>
                <Button onClick={this.handleClose}>Cancel</Button>
                <h4>{isCreate ? 'Add Note Type' : 'Edit Note Type'}</h4>
                <Button
                  data-cy='note-type-save'
                  onClick={handleCreateOrUpdate}
                >
                  {isCreateOrUpdating ? 'Loading' : 'Save'}
                </Button>
              </HeaderActions>

              <div className='content' style={{ width: '70%' }}>
                {shouldShowCategories && (
                  <NoteCategoryContainer>
                    <CategoryPlatter
                      onClick={e => this.openCategorySelection(e)}
                      className='category-platter'
                    >
                      <div>Note Category</div>
                      <SelectLabel>{emrNoteType?.name || 'select'}</SelectLabel>
                    </CategoryPlatter>
                    {categoryOptionsOpen && (
                      <SectionOptions className='categories-dropdown'>
                        {ntCategories.map((cat, idx) => {
                          return (
                            <SectionItem
                              key={idx}
                              onClick={() => this.handleCategoryClick(cat)}
                              className='categories-dropdown'
                            >
                              {cat.name}
                            </SectionItem>
                          )
                        })}
                      </SectionOptions>

                    )}
                  </NoteCategoryContainer>
                )}
                <ScriptNameInput
                  name='noteTypeName'
                  value={noteTypeName}
                  type='text'
                  placeholder='Enter note type name'
                  onChange={this.handleChange}
                />
                <ScriptNameTip>Choose a name that is easy to say and remember</ScriptNameTip>

                <DragDropContext onDragEnd={this.handleDragEnd} onDragStart={this.handleStartDrag}>
                  <Droppable droppableId='droppable'>
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {this.state.noteTypeSections.map((block, blockIdx) => {
                          return this.renderNewSectionBlock(block, blockIdx, false, block.id === 'new-section')
                        })}
                      </div>)}
                  </Droppable>
                </DragDropContext>

                {!isNewSectionBeingCreated && !isDragging && (
                  <AddSectionContainer>
                    <AddSectionButton className='add-section-btn' onClick={this.handleAddSection} data-cy='add-note-type-add-section'>+ Add Section</AddSectionButton>
                  </AddSectionContainer>
                )}
              </div>

            </Body>
          </Container>
        </InvisibleContainer>
        {
          showDeleteModal &&
            <DeleteItemModal
              handleDelete={() => { this.deleteSectionAtIndex(idxToDelete) }}
              handleClose={this.closeDeleteModal}
              deleteString='Delete Section and Section Content?'
            />
        }
      </div>

    )
  }
}

export default withApollo(NotetypeEditor)
